import { createContext, useMemo } from "react"

import {
  APP_STYLE_SETTINGS_FINANWAY,
  setInitialTitleFavicon,
} from "./constants"

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
export const AppContext = createContext()

const FinanwayAppWrapper = ({ children }: $TSMigrationFixMe) => {
  const settings = useMemo(() => {
    return APP_STYLE_SETTINGS_FINANWAY
  }, [])

  if (settings) {
    setInitialTitleFavicon(settings)
  }

  return (
    <AppContext.Provider value={{ settings }}>{children}</AppContext.Provider>
  )
}

export default FinanwayAppWrapper
